import React from 'react';
import { Input } from 'antd';
import { twMerge } from 'tailwind-merge';
import { TextAreaProps } from 'antd/es/input';

const { TextArea } = Input;

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  required?: boolean;
  label?: string;
  error?: string;
  onChange?: (e) => void;
  name?: string;
}

export function InputArea(props: Props & TextAreaProps) {
  const { className, classNameLabel, label, classNameInput, name, error, required, ...prop } =
    props;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 block', classNameLabel)}
        >
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <TextArea
        name={name}
        className={twMerge('border border-gray_300', classNameInput)}
        status={error ? 'error' : ''}
        {...prop}
      />
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
